var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.5875 0 0 3.5875 0 8C0 12.4125 3.5875 16 8 16C12.4125 16 16 12.4125 16 8C16 3.5875 12.4125 0 8 0Z",
    fill: "#F73232"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66523 12C8.66523 12.3687 8.36523 12.6656 7.99961 12.6656C7.63398 12.6656 7.33398 12.3656 7.33398 12C7.33398 11.6343 7.63398 11.3344 7.99961 11.3344C8.36523 11.3344 8.66523 11.6312 8.66523 12Z",
    fill: "#ECEFF1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66523 9.33435C8.66523 9.7031 8.36523 9.99998 7.99961 9.99998C7.63398 9.99998 7.33398 9.69998 7.33398 9.33435V3.99998C7.33398 3.63123 7.63398 3.33435 7.99961 3.33435C8.36523 3.33435 8.66523 3.63435 8.66523 3.99998V9.33435Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.e4a1563f835ed3c56dc0c3dab2303ea2.svg";
export { ForwardRef as ReactComponent };